module.exports = __webpack_public_path__ + "img/editOrderTypeDialog.7637600c.jpg";